module.exports = __webpack_public_path__ + "img/buttonSlid.5ae8caa4.svg";